import { omit } from 'lodash';

export class CommunicationPreferenceService {
  getUpdateDataOptionsKV(
    data: {
      smsOptions: any;
      callOptions: any;
      emailOptions: any;
      mailOptions: any;
    },
    merge: boolean = false,
  ) {
    const emailOptionsData = {
      ...omit(data.emailOptions, ['doNotSendTransactionalEmails', 'doNotSendMarketingEmails']),
      transactionalEmails: !data.emailOptions.doNotSendTransactionalEmails,
      marketingEmails: !data.emailOptions.doNotSendMarketingEmails,
    };

    const smsOptionsData = {
      ...omit(data.smsOptions, ['doNotSendTransactionalSms', 'doNotSendMarketingSms']),
      transactionalSms: !data.smsOptions.doNotSendTransactionalSms,
      marketingSms: !data.smsOptions.doNotSendMarketingSms,
    };

    if (merge) {
      const mailOptionsData = {
        ...omit(data.mailOptions, ['doNotSendMarketingMail']),
        marketingMail: !data.mailOptions.doNotSendMarketingMail,
      };

      return {
        ...data.callOptions,
        ...emailOptionsData,
        ...smsOptionsData,
        ...mailOptionsData,
      };
    } else {
      const mailOptionsData = {
        ...omit(data.mailOptions, ['doNotSendMarketingMail', 'noMail']),
      };

      return {
        callOptions: data.callOptions,
        mailOptions: mailOptionsData,
        emailOptions: emailOptionsData,
        smsOptions: smsOptionsData,
        marketingMail: !data.mailOptions.doNotSendMarketingMail,
        noMail: data.mailOptions.noMail,
      };
    }
  }

  getMailOptionsKV(data: any) {
    return {
      gourmetRestaurantsMail: data.gourmetRestaurantsMail,
      monthlyInvoiceMail: data.monthlyInvoiceMail,
      reactivationPostcardsMail: data.reactivationPostcardsMail,
      happyBirthdayPostcardsMail: data.happyBirthdayPostcardsMail,
      noMail: data.noMail,
      doNotSendMarketingMail: !data.marketingMail,
    };
  }

  getEmailOptionsKV(data: any) {
    return {
      doNotSendTransactionalEmails: !data.transactionalEmails,
      doNotSendMarketingEmails: !data.marketingEmails,
      addPaymentSourceEmail: data.addPaymentSourceEmail,
      updatePaymentSourceEmail: data.updatePaymentSourceEmail,
      defaultPaymentSourceEmail: data.defaultPaymentSourceEmail,
      deletePaymentSourceEmail: data.deletePaymentSourceEmail,
      apologyRefundEmail: data.apologyRefundEmail,
      blockDriverEmail: data.blockDriverEmail,
      cancellationFeeDisputeFailedEmail: data.cancellationFeeDisputeFailedEmail,
      cancellationFeeDisputeSuccessEmail: data.cancellationFeeDisputeSuccessEmail,
      closingAccountEmail: data.closingAccountEmail,
      falseTripDisputeFailedEmail: data.falseTripDisputeFailedEmail,
      falseTripDisputeSuccessEmail: data.falseTripDisputeSuccessEmail,
      fareDisputeFailedEmail: data.fareDisputeFailedEmail,
      fareDisputeSuccessEmail: data.fareDisputeSuccessEmail,
      findLostItemFailedEmail: data.findLostItemFailedEmail,
      refundEmail: data.refundEmail,
      giftCardNotificationEmail: data.giftCardNotificationEmail,
      giftCardReceiptEmail: data.giftCardReceiptEmail,
      membershipRenewalReminderEmail: data.membershipRenewalReminderEmail,
      membershipConfirmationEmail: data.membershipConfirmationEmail,
      membershipFailedEmail: data.membershipFailedEmail,
      membershipReceiptEmail: data.membershipReceiptEmail,
      membershipTrialConfirmationEmail: data.membershipTrialConfirmationEmail,
      membershipTrialWillEndEmail: data.membershipTrialWillEndEmail,
      gogoGourmetReceiptEmail: data.gogoGourmetReceiptEmail,
      needLoveRefundEmail: data.needLoveRefundEmail,
      newRideCreditsNotificationEmail: data.newRideCreditsNotificationEmail,
      noPaymentMethodOnFileEmail: data.noPaymentMethodOnFileEmail,
      noRidesCallerEmail: data.noRidesCallerEmail,
      noShowReceiptEmail: data.noShowReceiptEmail,
      partnerCreditsNotificationEmail: data.partnerCreditsNotificationEmail,
      partnerRidesNotificationEmail: data.partnerRidesNotificationEmail,
      refundRideEmail: data.refundRideEmail,
      rideCancellationReceiptEmail: data.rideCancellationReceiptEmail,
      rideCreditsRenewalEmail: data.rideCreditsRenewalEmail,
      rideHistoryEmail: data.rideHistoryEmail,
      rideReceiptEmail: data.rideReceiptEmail,
      scheduledRideCancelledEmail: data.scheduledRideCancelledEmail,
      scheduledRideChangedEmail: data.scheduledRideChangedEmail,
      scheduledRideConfirmedEmail: data.scheduledRideConfirmedEmail,
      scheduledRideReminderDayBeforeEmail: data.scheduledRideReminderDayBeforeEmail,
      scheduledRideUnpaidServicesEmail: data.scheduledRideUnpaidServicesEmail,
      scheduledRidePreauthFailedEmail: data.scheduledRidePreauthFailedEmail,
      scheduledGroceryCanceledEmail: data.scheduledGroceryCanceledEmail,
      scheduledGroceryChangedEmail: data.scheduledGroceryChangedEmail,
      scheduledGroceryConfirmedEmail: data.scheduledGroceryConfirmedEmail,
      scheduledGroceryReminderEmail: data.scheduledGroceryReminderEmail,
      scheduledGroceryUnpaidServicesEmail: data.scheduledGroceryUnpaidServicesEmail,
      scheduledGroceryPreauthFailedEmail: data.scheduledGroceryPreauthFailedEmail,
      scheduledDeliveryReminderEmail: data.scheduledDeliveryReminderEmail,
      scheduledDeliveryUnpaidServicesEmail: data.scheduledDeliveryUnpaidServicesEmail,
      scheduledDeliveryPreauthFailedEmail: data.scheduledDeliveryPreauthFailedEmail,
      surgePricingWasConfirmedEmail: data.surgePricingWasConfirmedEmail,
      welcomeEmail: data.welcomeEmail,
      welcomeEmailForUsersWithPartners: data.welcomeEmailForUsersWithPartners,
      deactivationPassedAwayEmail: data.deactivationPassedAwayEmail,
      suspendingAccountMembershipEmail: data.suspendingAccountMembershipEmail,
      groceryReceiptEmail: data.groceryReceiptEmail,
      groceryReceivedEmail: data.groceryReceivedEmail,
      groceryOrderReminderEmail: data.groceryOrderReminderEmail,
      refundDepositDeniedEmail: data.refundDepositDeniedEmail,
      accountReactivateEmail: data.accountReactivateEmail,
      driverCanceledEmail: data.driverCanceledEmail,
      freeTrialReminderEmail: data.freeTrialReminderEmail,
      groceryOrderUpdateEmail: data.groceryOrderUpdateEmail,
      homeServicesReceiptEmail: data.homeServicesReceiptEmail,
      crmActivationCampaignEmail: data.crmActivationCampaignEmail,
      crmActivationHardRegistrationCampaignEmail: data.crmActivationHardRegistrationCampaignEmail,
      crmMomentumEngagementCampaignEmail: data.crmMomentumEngagementCampaignEmail,
      crmCrossSellGourmetCampaignEmail: data.crmCrossSellGourmetCampaignEmail,
      crmCrossSellGroceriesCampaignEmail: data.crmCrossSellGroceriesCampaignEmail,
      crmCrossSellHomeServicesCampaignEmail: data.crmCrossSellHomeServicesCampaignEmail,
      crmReactivationCampaignEmail: data.crmReactivationCampaignEmail,
      crmResurrectionCampaignEmail: data.crmResurrectionCampaignEmail,
      crmActivationDormantSoftRegistrationCampaignEmail: data.crmActivationDormantSoftRegistrationCampaignEmail,
      crmActivationNewUserGroceryRegistrationEmail: data.crmActivationNewUserGroceryRegistrationEmail,
      crmActivationDormantHardRegistrationCampaignEmail: data.crmActivationDormantHardRegistrationCampaignEmail,
      crmActivationNewUserAddedCCRegistrationEmail: data.crmActivationNewUserAddedCCRegistrationEmail,
      crmActivationNewUserGourmetRegistrationEmail: data.crmActivationNewUserGourmetRegistrationEmail,
      crmActivationNewUserOnlineRegistrationEmail: data.crmActivationNewUserOnlineRegistrationEmail,
      crmActivationNewUserPhoneRegistrationEmail: data.crmActivationNewUserPhoneRegistrationEmail,
      crmActivationNewUserPickedPlanRegistrationEmail: data.crmActivationNewUserPickedPlanRegistrationEmail,
      crmRevivalCampaignEmail: data.crmRevivalCampaignEmail,
    };
  }

  getSmsOptionsKV(data: any) {
    return {
      doNotSendTransactionalSms: !data.transactionalSms,
      doNotSendMarketingSms: !data.marketingSms,
      driverAcceptedRideSms: data.driverAcceptedRideSms,
      driverCancelledRideSms: data.driverCancelledRideSms,
      operatorCancelledRideSms: data.operatorCancelledRideSms,
      redispatchedRideSms: data.redispatchedRideSms,
      riderCancelledRideSms: data.riderCancelledRideSms,
      scheduledRideConfirmationSms: data.scheduledRideConfirmationSms,
      scheduledRideSurgeSmsForCaller: data.scheduledRideSurgeSmsForCaller,
      nextRideSmsOrdering: 'nextRideSmsOrdering' in data ? data.nextRideSmsOrdering !== false : undefined,
      scheduledRideCancelledSms: data.scheduledRideCancelledSms,
      scheduledGroceryConfirmationSms: data.scheduledGroceryConfirmationSms,
      deliveryArrivalSms: data.deliveryArrivalSms,
      groceryOrderOutsideReminderSms: data.groceryOrderOutsideReminderSms,
      crmActivationCampaignSms: data.crmActivationCampaignSms,
      crmActivationHardRegistrationCampaignSms: data.crmActivationHardRegistrationCampaignSms,
      crmMomentumEngagementCampaignSms: data.crmMomentumEngagementCampaignSms,
      crmCrossSellGourmetCampaignSms: data.crmCrossSellGourmetCampaignSms,
      crmCrossSellGroceriesCampaignSms: data.crmCrossSellGroceriesCampaignSms,
      crmCrossSellHomeServicesCampaignSms: data.crmCrossSellHomeServicesCampaignSms,
      crmReactivationCampaignSms: data.crmReactivationCampaignSms,
      crmResurrectionCampaignSms: data.crmResurrectionCampaignSms,
      crmActivationDormantSoftRegistrationCampaignSms: data.crmActivationDormantSoftRegistrationCampaignSms,
      crmActivationNewUserGroceryRegistrationSms: data.crmActivationNewUserGroceryRegistrationSms,
      crmActivationDormantHardRegistrationCampaignSms: data.crmActivationDormantHardRegistrationCampaignSms,
      crmActivationNewUserAddedCCRegistrationSms: data.crmActivationNewUserAddedCCRegistrationSms,
      crmActivationNewUserGourmetRegistrationSms: data.crmActivationNewUserGourmetRegistrationSms,
      crmActivationNewUserOnlineRegistrationSms: data.crmActivationNewUserOnlineRegistrationSms,
      crmActivationNewUserPhoneRegistrationSms: data.crmActivationNewUserPhoneRegistrationSms,
      crmActivationNewUserPickedPlanRegistrationSms: data.crmActivationNewUserPickedPlanRegistrationSms,
      crmRevivalCampaignSms: data.crmRevivalCampaignSms,
    };
  }

  getCallOptionsKV(data: any) {
    return {
      driverArriving: data.driverArriving,
      scheduledRideSurgeCall: data.scheduledRideSurgeCall,
      scheduledRideCall: data.scheduledRideCall,
      pricePendingRideCall: data.pricePendingRideCall,
      callRiderPriceChange: data.callRiderPriceChange,
      callRiderDriverCanceled: data.callRiderDriverCanceled,
      cancellationFeeDisputeFailedCall: data.cancellationFeeDisputeFailedCall,
      sendNeedLoveAutomatedCall: data.sendNeedLoveAutomatedCall,
      sendNeedLoveRefundAutomatedCall: data.sendNeedLoveRefundAutomatedCall,
      callRiderDriverDetails: data.callRiderDriverDetails,
      pricePendingRideAfterDateExpiredCall: data.pricePendingRideAfterDateExpiredCall,
      callRiderTripCost: data.callRiderTripCost,
      callNewDriverInfo: data.callNewDriverInfo,
      callWarnNoShowFee: data.callWarnNoShowFee,
      scheduledRidePayForAnyUnpaidServicesFailedCall: data.scheduledRidePayForAnyUnpaidServicesFailedCall,
      scheduledRideUnpaidServicesCallIn24Hours: data.scheduledRideUnpaidServicesCallIn24Hours,
      scheduledRidePreauthFailedCallIn24Hours: data.scheduledRidePreauthFailedCallIn24Hours,
      scheduledRideReminderDayBeforeCall: data.scheduledRideReminderDayBeforeCall,
      scheduledRideCustomReminderCall: data.scheduledRideCustomReminderCall,
      scheduledGroceryPayForAnyUnpaidServicesFailedCall: data.scheduledGroceryPayForAnyUnpaidServicesFailedCall,
      scheduledGroceryUnpaidServicesCallIn24Hours: data.scheduledGroceryUnpaidServicesCallIn24Hours,
      scheduledGroceryPreauthFailedCallIn24Hours: data.scheduledGroceryPreauthFailedCallIn24Hours,
      scheduledGroceryBeforeTheDayCall: data.scheduledGroceryBeforeTheDayCall,
      scheduledGroceryCustomReminderCall: data.scheduledGroceryCustomReminderCall,
      scheduledDeliveryPayForAnyUnpaidServicesFailedCall: data.scheduledDeliveryPayForAnyUnpaidServicesFailedCall,
      scheduledDeliveryUnpaidServicesCallIn24Hours: data.scheduledDeliveryUnpaidServicesCallIn24Hours,
      scheduledDeliveryPreauthFailedCallIn24Hours: data.scheduledDeliveryPreauthFailedCallIn24Hours,
      scheduledDeliveryReminderCall: data.scheduledDeliveryReminderCall,
      callPartnerCallerAboutPartnerCredits: data.callPartnerCallerAboutPartnerCredits,
      callPartnerCallerAboutPartnerRides: data.callPartnerCallerAboutPartnerRides,
      callWarnInProgressDriverCancellation: data.callWarnInProgressDriverCancellation,
      ridesMarketingCalls: data.ridesMarketingCalls,
      gourmetMarketingCalls: data.gourmetMarketingCalls,
      groceriesMarketingCalls: data.groceriesMarketingCalls,
      subscriptionChargeSuccessCall: data.subscriptionChargeSuccessCall,
      subscriptionChargeFailedCall: data.subscriptionChargeFailedCall,
      membershipRenewalReminderCall: data.membershipRenewalReminderCall,
      membershipTrialWillEndIn3DaysCall: data.membershipTrialWillEndIn3DaysCall,
      weeklyCheckInMarketingCall: data.weeklyCheckInMarketingCall,
      groceryOrderShoppingCall: data.groceryOrderShoppingCall,
      groceryOrderShoppingCompleteCall: data.groceryOrderShoppingCompleteCall,
      groceryOrderInTransitCall: data.groceryOrderInTransitCall,
      groceryOrderCanceledCall: data.groceryOrderCanceledCall,
      groceryOrderReminderCall: data.groceryOrderReminderCall,
      refundDepositDeniedCall: data.refundDepositDeniedCall,
      noCalls: data.noCalls,
      marketingCalls: data.marketingCalls,
      priceConfirm: data.priceConfirm,
      groceryOrderOutsideReminderCall: data.groceryOrderOutsideReminderCall,
      etaDelayCall: data.etaDelayCall,
      deliveryArrivalCall: data.deliveryArrivalCall,
      deliveryAfterOrderCall: data.deliveryAfterOrderCall,
      deliveryAfterHoursOrderStatusUpdateCall: data.deliveryAfterHoursOrderStatusUpdateCall,
      isSendUserPhoneNumberInDriverAcceptedTextMessage: data.isSendUserPhoneNumberInDriverAcceptedTextMessage,
    };
  }
}
